/**
 * File view component.
 * @module components/Views/Licitacao/ContratoView
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@plone/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import PDFBlockView from '@eeacms/volto-pdf-block/components/manage/PDFViewer/BlockView';
import FileType from '@kitconcept/volto-light-theme/helpers/Filetype';

/**
 * Contrato view component class.
 * @function ContratoView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const ContratoView = ({ content }) => {
  const aditivos = content.aditivos || [];
  const contentType = content.file['content-type'];
  const downloadUrl =
    content.file?.download && flattenToAppURL(content.file.download);
  return (
    <Container id="page-document" className="view-wrapper documento-view">
      <header className="head-title">
        <span className={`tipo_documento`}>{content.tipo_documento.title}</span>
      </header>
      <h1 className="documentFirstHeading">
        {content.title}
        {content.subtitle && ` - ${content.subtitle}`}
      </h1>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}
      {contentType === 'application/pdf' && (
        <PDFBlockView data={{ url: downloadUrl }} />
      )}
      {downloadUrl && (
        <p>
          <a href={downloadUrl}>{content.file.filename}</a>{' '}
          <span>
            ({FileType(content?.file['content-type'])}/{' '}
            {content.file?.size < 1000000
              ? Math.round(content.file.size / 1000)
              : Math.round(content.file.size / 1000000)}
            {content.file?.size < 1000000 ? 'KB' : 'MB'})
          </span>
        </p>
      )}
      {aditivos.length > 0 && (
        <div className="aditivos-list">
          <h3>Aditivos</h3>
          <ul>
            {aditivos.map((aditivo) => (
              <li key={aditivo['@id']}>
                <a href={flattenToAppURL(aditivo['@id'])}>{aditivo.title}</a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
ContratoView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      download: PropTypes.string,
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default ContratoView;
